(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ceooud-premium-featured"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ceooud-favourites')) {
 customElements.define('ceooud-favourites', class extends HTMLElement {
  connectedCallback() {
   this.track = this.querySelector('.premium-favourites-carousel');
   this.controls = this.querySelector('.premium-carousel-controls');
   this.hint = this.querySelector('.premium-carousel-hint');
   this.previous = this.querySelector('[data-direction="-1"]');
   this.next = this.querySelector('[data-direction="1"]');
   this.progress = this.querySelector('.premium-carousel-progress');
   if (!this.track || !this.controls) return;
   this.abort = new AbortController();
   const signal = this.abort.signal;
   this.track.addEventListener('scroll', () => {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.update());
   }, { passive: true, signal });
   this.controls.addEventListener('click', event => {
    const button = event.target.closest('button[data-direction]');
    if (!button || button.disabled) return;
    const card = this.track.firstElementChild;
    const stride = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
    const visible = Math.max(1, Math.round(this.track.clientWidth / stride));
    const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
    this.track.scrollBy({ left: stride * visible * Number(button.dataset.direction) * rtl, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
   }, { signal });
   this.observer = new ResizeObserver(() => this.update());
   this.observer.observe(this.track);
   this.update();
  }
  update() {
   const maximum = this.track.scrollWidth - this.track.clientWidth;
   const position = Math.max(0, Math.min(maximum, Math.abs(this.track.scrollLeft)));
   const overflowing = maximum > 2;
   this.controls.hidden = !overflowing;
   this.hint.hidden = !overflowing;
   this.previous.disabled = position <= 2;
   this.next.disabled = position >= maximum - 2;
   const fraction = Math.min(1, (position + this.track.clientWidth) / Math.max(1, this.track.scrollWidth));
   this.progress.style.setProperty('--carousel-progress', fraction);
   this.progress.setAttribute('aria-valuenow', Math.round(fraction * 100));
  }
  disconnectedCallback() {
   this.abort?.abort();
   this.observer?.disconnect();
   cancelAnimationFrame(this.frame);
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
